"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishedStatus = void 0;
exports.PublishedStatus = {
    PUBLISHED: {
        text: "공개",
        color: "success",
    },
    PRIVATE: {
        text: "숨김",
        color: "danger",
    },
    BLOCKED: {
        text: "차단",
        color: "danger",
    },
    UNBLOCKED: {
        text: "차단 해제",
        color: "success",
    },
};
